import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { normalizeResponseData, type ResponseData } from "~/features/auth/login/api/ResetPassword";

export type FieldValidationResults = ResponseData["validationResults"];

interface Props {
  pwd: string;
  checkPwd: string;
  token: string;
  newCustomer: boolean;
}

export function sendUpdatePasswordRequest(data: Props): Promise<ResponseData> {
  const body = JSON.stringify({
    pwd: data.pwd,
    checkPwd: data.checkPwd,
    token: data.token,
    newCustomer: data.newCustomer,
  });

  return occFetch(occUrl("/users/password/change"), {
    body,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error("Error setting password");
    }
    return normalizeResponseData(await response.json());
  });
}
